import { Collapse, IconButton, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';
import { MainInput } from '../components/Styles';
import { cardShell } from './styles';

export const filterFunnelIcon = (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M4 5h16l-6.5 8v5.5l-3 1.8V13z" />
  </svg>
);

export const exportIcon = (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M12 3v12" />
    <path d="m7 10 5 5 5-5" />
    <path d="M4 21h16" />
  </svg>
);

export const plusIcon = (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export function FilterChips({ options, value, onChange }) {
  return (
    <div className="cz-wrap" style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      {options.map(([optValue, label]) => (
        <button
          key={optValue === '' || optValue == null ? 'all' : String(optValue)}
          type="button"
          className={`cz-chip ${value === optValue ? 'on' : ''}`}
          onClick={() => onChange(optValue)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default function SearchFilterBar({
  placeholder,
  value,
  onChange,
  onSearch,
  isMobile,
  filterOpen,
  onToggleFilter,
  filterLabel,
  actions,
  children,
  extraAdornment,
}) {
  return (
    <>
      <div className="cz-wrap" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '4px 8px 4px 18px',
            borderRadius: 999,
            background: 'var(--s04)',
            border: '1px solid var(--s10)',
            minWidth: isMobile ? '100%' : 220,
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--mut)" strokeWidth="1.8" strokeLinecap="round" aria-hidden>
            <circle cx="11" cy="11" r="7" />
            <path d="m20 20-3.2-3.2" />
          </svg>
          <MainInput
            placeholder={placeholder}
            value={value}
            onChange={({ target }) => onChange(target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && onSearch) onSearch();
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {extraAdornment}
                  {onSearch && (
                    <IconButton onClick={onSearch} edge="end" sx={{ color: 'var(--tx2)' }}>
                      <Search />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
            sx={{
              flex: 1,
              my: 0,
              '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
              '& .MuiInputBase-input': { py: 1 },
            }}
          />
        </div>
        {onToggleFilter && (
          <button type="button" className={`cz-chip ${filterOpen ? 'on' : ''}`} onClick={onToggleFilter}>
            {filterLabel}
            {filterFunnelIcon}
          </button>
        )}
        {actions}
      </div>
      {onToggleFilter && children != null && (
        <Collapse in={!!filterOpen}>
          <div style={cardShell}>{children}</div>
        </Collapse>
      )}
    </>
  );
}
